import { StandardEvents } from '@shopify/events';
class WelloraSelectionNote extends HTMLElement {
 connectedCallback(){
  this.controller=new AbortController(); this.generation=0;
  (this.closest('quick-add-dialog')||this.closest('.shopify-section'))?.addEventListener(StandardEvents.productSelect, e=>this.updateSelection(e),{signal:this.controller.signal});
 }
 disconnectedCallback(){this.controller?.abort();this.generation++;}
 async updateSelection(event){
  if(!event.promise)return;
  const generation=++this.generation;
  this.setAttribute('aria-busy','true');
  const contents=this.querySelector('.w-selection-note__contents');
  if(contents)contents.textContent='Updating selected contents…';
  try{
   const {detail}=await event.promise;
   if(generation!==this.generation||!this.isConnected)return;
   if(detail && 'resource' in detail && !detail.resource){this.querySelector('.w-selection-note__option').textContent='Unavailable option combination';this.querySelector('.w-selection-note__contents').textContent='This option combination is unavailable. Choose another option.';this.dataset.variantId='';return;}
   const incoming=[...(detail?.html?.querySelectorAll('wellora-selection-note')||[])].find(x=>x.dataset.blockId===this.dataset.blockId&&x.dataset.productId===(detail.productId||this.dataset.productId));
   if(incoming){this.innerHTML=incoming.innerHTML;this.dataset.variantId=incoming.dataset.variantId||'';this.dataset.productId=incoming.dataset.productId;}
   else if(contents){contents.textContent='This option combination is unavailable. Choose another option.';this.dataset.variantId='';}
  }catch(error){
   if(generation!==this.generation||!this.isConnected)return;
   if(contents)contents.textContent='Selected contents could not load. Review the option guide below, or refresh this page.';
  }finally{if(generation===this.generation)this.removeAttribute('aria-busy');}
 }
}
if(!customElements.get('wellora-selection-note'))customElements.define('wellora-selection-note',WelloraSelectionNote);
